module.exports = __webpack_public_path__ + "static/emoticons-23ebf43efa22c2b1c01c5d0a6904f5c2.png";